import { OccConfig } from '@spartacus/core';

export const customOccCartConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        /* eslint-disable max-len */
        carts:
          'b2bUsers/${userId}/carts?fields=carts(FULL)',
        cart: 'b2bUsers/${userId}/carts/${cartId}?fields=FULL',
        createCart:
          'b2bUsers/${userId}/carts?fields=FULL',
        addEntries: 'b2bUsers/${userId}/carts/${cartId}/entries',
        updateEntries: 'b2bUsers/${userId}/carts/${cartId}/entries/${entryNumber}',
        removeEntries: 'b2bUsers/${userId}/carts/${cartId}/entries/${entryNumber}',
        addEmail: 'users/${userId}/carts/${cartId}/email',
        deleteCart: 'b2bUsers/${userId}/carts/${cartId}',
        cartVoucher: 'users/${userId}/carts/${cartId}/vouchers',
        saveCart:
          'b2bUsers/${userId}/carts/${cartId}/save?saveCartName=${saveCartName}&saveCartDescription=${saveCartDescription}',
        validate: 'users/${userId}/carts/${cartId}/validate?fields=FULL',
        /* eslint-enable */
      },
    },
  },
};
